import icon from 'vue-svgicon';

icon.register({
    'regular/shopping-cart-check': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M14.019 4.1l-3.935 5.25a1.016 1.016 0 0 1-1.531.109L6.519 7.425" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><circle pid="1" cx="6.375" cy="20.968" r="1.875" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><circle pid="2" cx="13.875" cy="20.968" r="1.875" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="3" d="M.75 7.093l2.329 7.887a1.5 1.5 0 0 0 1.45 1.113h10.818A1.5 1.5 0 0 0 16.8 14.98l3.238-12.154a2.249 2.249 0 0 1 2.174-1.67h1.038" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
